// The description and the canonical address of a page. Each page sets them when it opens and puts the previous ones back when it closes.
const SITE = "https://www.gozzoguide.com";

export function applySeo({ description, path }) {
  const meta = document.querySelector('meta[name="description"]');
  const previousDescription = meta ? meta.getAttribute("content") : null;
  if (meta && description) meta.setAttribute("content", description);

  let link = document.querySelector('link[rel="canonical"]');
  const created = !link;
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  const previousHref = link.getAttribute("href");
  link.setAttribute("href", SITE + path);

  return () => {
    if (meta && previousDescription !== null) meta.setAttribute("content", previousDescription);
    if (created) link.remove();
    else if (previousHref !== null) link.setAttribute("href", previousHref);
  };
}
